module.exports = __webpack_public_path__ + "img/CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Plain_Concrete.Concrete.ae5cd954.png";